import { render } from "./ai-dictionary-tree-list.vue?vue&type=template&id=51225db9"
import script from "./ai-dictionary-tree-list.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-dictionary-tree-list.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/dictionary-components/ai-dictionary-tree-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51225db9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51225db9', __exports__)) {
    api.reload('51225db9', __exports__)
  }
  
  module.hot.accept("./ai-dictionary-tree-list.vue?vue&type=template&id=51225db9", () => {
    api.rerender('51225db9', render)
  })

}


export default __exports__